import { ActionContext, ActionTree } from 'vuex';
import { RootState } from '@/store';
import ToolState from './state';
import { MutationTypes } from './mutation-types';
import axios from 'axios';
import compareValues from '@/helper/sortHelper';

type Context = ActionContext<ToolState, RootState>;
const actions: ActionTree<ToolState, RootState> = {
    async init(context: Context) {
        const ADMIN_RESOURCE_PATH = 'admin.json';
        const HISTORY_RESOURCE_PATH = 'history.json';

        axios.get(ADMIN_RESOURCE_PATH)
             .then((response) => {
                  context.commit(MutationTypes.LOAD_ADMIN, response.data);
             })
             .catch((error) => {
                  console.log(error);
             });

        axios.get(HISTORY_RESOURCE_PATH)
             .then((response) => {
                  const histories = response.data;
                  histories.sort(compareValues('date', 'desc'));
                  context.commit(MutationTypes.LOAD_HISTORY, response.data);
             })
             .catch((error) => {
                  console.log(error);
             });
    },
};

export default actions;
